import React from "react";

const LEVELS = [
  { value: "very_high", label: "Very High", color: "bg-green-500", min: 80 },
  { value: "high", label: "High", color: "bg-yellow-400", min: 60 },
  { value: "low", label: "Low", color: "bg-red-400", min: 40 },
  { value: "very_low", label: "Very Low", color: "bg-zinc-900", min: 0 },
];

export function scoreValueToLevel(v) {
  if (v === "" || v === null || v === undefined) return null;
  const n = Number(v);
  if (n >= 80) return "very_high";
  if (n >= 60) return "high";
  if (n >= 40) return "low";
  return "very_low";
}

export function levelToMin(level) {
  const f = LEVELS.find((l) => l.value === level);
  return f ? f.min : "";
}

export default function ConfidenceScorePicker({ value, onChange, testId }) {
  return (
    <div className="flex flex-wrap gap-2" data-testid={testId}>
      {LEVELS.map((l) => {
        const active = value === l.value;
        return (
          <button
            key={l.value}
            type="button"
            onClick={() => onChange(active ? "" : l.value)}
            data-testid={`${testId}-${l.value}`}
            className={`flex items-center gap-2 rounded-md border px-3 py-1.5 text-sm font-medium transition-colors ${
              active
                ? "border-zinc-950 bg-zinc-50 text-zinc-950 shadow-sm"
                : "border-zinc-200 bg-white text-zinc-700 hover:border-zinc-400"
            }`}
          >
            <span className={`h-2.5 w-2.5 rounded-full ${l.color}`} />
            {l.label}
          </button>
        );
      })}
    </div>
  );
}
